/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        tooltip: {
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "8px",
                            blur: "16px",
                            spread: "0px",
                            color: "#0000001F",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "0px",
                            blur: "4px",
                            spread: "0px",
                            color: "#00000029",
                        },
                    ],
                    stringValue: "0px 8px 16px 0px #0000001F, 0px 0px 4px 0px #00000029",
                },
                type: "shadow",
            },
            color: {
                value: "#1e1e1e",
                type: "color",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1.25rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            paddingHorizontal: {
                value: "16px",
                type: "dimension",
            },
            paddingVertical: {
                value: "8px",
                type: "dimension",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            maxWidth: {
                value: "234px",
                type: "dimension",
            },
            arrow: {
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "8px",
                                blur: "16px",
                                spread: "0px",
                                color: "#0000001F",
                            },
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "0px",
                                blur: "4px",
                                spread: "0px",
                                color: "#00000029",
                            },
                        ],
                        stringValue: "0px 8px 16px 0px #0000001F, 0px 0px 4px 0px #00000029",
                    },
                    type: "shadow",
                },
            },
            light: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            dark: {
                backgroundColor: {
                    value: "#1e1e1e",
                    type: "color",
                },
                color: {
                    value: "#ffffff",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
